/* eslint-disable no-useless-escape */
import * as intl from 'react-intl-universal';
import * as yup from 'yup';

class MfaDeactivateValidation {
  public static GetValidationSchema(): yup.ObjectSchema | undefined {
    const validationSchema: yup.ObjectSchema = yup.object().shape({
      password: yup
        .string()
        .trim()
        .required(intl.get('ERR_FORM_PASSWORD_REQUIRED_MESSAGE')),
    });
    return validationSchema;
  }
}

export default MfaDeactivateValidation;
